import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getBrandCampaign = async (params = {}, id: number | null) => {
  const url = `${API_ENDPOINTS.PRODUCT.GET_BRAND_CAMPAIGN_STEP_LIST}/${id}`;
  let response = await axiosInstance.get(url, { params });
  const rowData = await response?.data;
  const data = Array.isArray(rowData.data?.data)
    ? rowData.data.data.map((item: any) => ({
        BrandCampiagnVisitPlanId: item?.BrandCampiagnVisitPlanId || 0,
        BrandCampiagnId: item.BrandCampiagnId || 0,
        AgendaType: item?.AgendaType || "-",
        Name: item?.StepName || "-",
        Level: item?.StepLevel || "-",
        Moye: item?.Moye || "-",

        AgendaSubTypeId: item?.AgendaSubTypeId,
        Description: item?.Description,
        SgpiId: item?.SgpiId,
        SgpiStatus: item?.SgpiStatus,
        CreateSurvey: item?.CreateSurvey,
        StepLevel: item?.StepLevel,
      }))
    : [];

  const stepLevelData = data.map((step: any) => ({
    id: String(step.StepLevel),
    label: String(step.StepLevel),
  }));
  return { rowData, data, stepLevelData };
};

export const GetSubAgendaType = async (params = {}) => {
  const url = `${API_ENDPOINTS.PRODUCT.GET_AGENDA_SUB_TYPES}`;
  let response = await axiosInstance.get(url, { params });

  const rowData = await response?.data;
  console.log("🚀 ~ GetSubAgendaType ~ rowData:", rowData);

  const data = Array.isArray(rowData?.data)
    ? rowData?.data.map((item: any) => ({
        id: item.Agendaid,
        label: item.Agendname,
      }))
    : [];
  console.log("SubAgenda_API_DATA", data);
  return { response, data };
};

export const getSGPILists = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.BRAND_CAMPAIGN.GET_SGPI_LISTS,
    { params: params }
  );
  const responseData = response?.data?.data;
  const data = Array.isArray(responseData)
    ? responseData.map((item: any) => ({
        id: item.SgpiId || "-",
        label: item.SgpiName || "-",
      }))
    : [];

  return { data };
};

export const addBrandCampaignSteps = async (ReqBody: any) => {
  const url = `${API_ENDPOINTS.PRODUCT.POST_BRAND_CAMPAIGN_STEP_LIST}`;
  let response = await axiosInstance.post(url, ReqBody);

  console.log(
    "🚀 ~ BrandCampaignRepo.ts:70 ~ addBrandCampaignSteps ~ response:",
    response
  );
  return response?.data;
};

export const UpdateBrandCampaignStep = async (ReqBody: any) => {
  let url = `${API_ENDPOINTS.PRODUCT.POST_UPDATE_CAMPAIGN_STEP}`;
  let response = await axiosInstance.post(url, ReqBody);
  return response?.data;
};

export const getSingleBrandCampaignStep = async (id: any) => {
  let response = await axiosInstance.get(
    `${API_ENDPOINTS.PRODUCT.GET_SINGLE_BRNADCAMPAIGN_STEP}/${id}`
  );
  const rowData = await response?.data;
  const formatedData = Array.isArray(rowData?.data?.SgpiArray)
    ? rowData.data.SgpiArray.map((item: any) => ({
        id: item.SgpiId,
        label: item.SgpiName,
      }))
    : [];
  return { formatedData, rowData };
};
